import { IconProps } from ".";

export const VirtualMachineIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      viewBox="3 3 26 26" // tightened from 0 0 32 32 to remove outer empty space
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.9997 16.4332V10.3761C27.9997 6.45705 25.2249 4 21.298 4H10.7018C6.77489 4 4 6.44539 4 10.3761V21.6211C4 25.5531 6.77489 27.9997 10.7018 27.9997H11.9238"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2932 16H4.03125"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81763 21.5132H10.5143"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81763 10.4868H10.5143M16.1355 10.4868H22.1809"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1396 22.3952C16.5984 22.4095 15.3542 23.4448 15.3542 25.2064C15.3542 26.3468 16.0328 27.3288 17.0084 27.7699C17.4182 27.936 17.8269 27.9995 18.1369 27.9995H24.7868C25.0969 27.9995 25.5081 27.9386 25.9233 27.7726C26.8988 27.3315 27.5746 26.3468 27.5746 25.2064C27.5746 23.4448 26.3306 22.4095 24.7894 22.3952C24.7894 21.2874 23.9202 19.0703 21.4645 19.0703C19.0088 19.0703 18.1396 21.2874 18.1396 22.3952Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
